module.exports = __webpack_public_path__ + "img/spring.17dbb19a.png";